export const addMatadorConnectScript = () => {
  if (window.matadorLiveChatWidget) {
    return;
  }

  const script = document.createElement("script");
  script.innerHTML = `
      (function(d, t) {
        var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
        g.src = "https://stg.matador.ai/_livechat.js";
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function() {
          matadorLiveChatWidget("ed9fbdb35cc76129534595449bcb027e6245953f");
        }
      })(document, "script");
    `;
  document.body.appendChild(script);
};
